
import { NO_INFORMATION } from "@/data/placeholders";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class CardItem extends Vue {
  @Prop({ type: String, required: true }) readonly title!: string;
  @Prop({ type: String, default: NO_INFORMATION }) readonly content!: string;
  @Prop({ type: Boolean, default: false }) readonly fullwidth!: boolean;

  get noInformation(): string {
    return NO_INFORMATION;
  }

  get containerClasses(): object {
    return {
      "sm:col-span-2": this.fullwidth,
      "sm:col-span-1": !this.fullwidth,
    };
  }
}
